import { Component, ViewChild, NgZone } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { UnityComponent } from './unity/unity.component';
import { Interface } from './interface';
import { ButtonRoundComponent } from './button-round/button-round.component';
import { PauseOverlayComponent } from './pause-overlay/pause-overlay.component';
import { SchemaComponent } from './schema/schema.component';
import { ChartComponent } from './chart/chart.component';
import { InfopanelComponent } from './infopanel/infopanel.component';
import { VideoComponent } from './video/video.component';
import { setInterval } from 'core-js/library/web/timers';
import { HttpClient } from '@angular/common/http';
declare var UnityLoader: any;
declare var SendMessage: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  languages = ['de', 'en', 'fr', 'it'];
  currentLocation = "Home";
  lastLocation = "Home";
  currentLanguage = "de";
  showInfo: boolean = true;
  interface;
  title = "";
  idleTime = true;

  firstVehicle = true;

  @ViewChild(UnityComponent) unity: UnityComponent;
  @ViewChild(SchemaComponent) schema: SchemaComponent;
  @ViewChild(ChartComponent) chart: ChartComponent;
  @ViewChild(InfopanelComponent) infopanel: InfopanelComponent;
  @ViewChild(VideoComponent) video: VideoComponent;
  @ViewChild(PauseOverlayComponent) pauseOverlay: PauseOverlayComponent;

  content: any = {
    "url": "http://localhost:8000/statistics",
    "languages": {
      "de": "deutsch",
      "fr": "français",
      "it": "italiano",
      "en": "english"
    },
    "idle":{
      "active": false,
      "time": 300
    },
    "de": {
      "labels": {
        "sprache": "Sprache",
        "fuellstand": "Füllstand",
        "kapazitaet": "Kapazität",
        "pufferspeicher": "Pufferspeicher",
        "endspeicher": "Endspeicher",
        "last7Days": "Letzten 7 Tage",
        "lastYear": "Letztes Jahr",
        "aktuell": "Aktuell",
        "biogas": "Biogas (CNG)",
        "hcng": "HCNG",
        "h2-350bar": "H2 35MPa",
        "h2-700bar": "H2 70MPa",
        "kWh": "kWh",
        "kgh": "kgh",
        "kW": "kW",
        "kg": "kg",
        "fuelcount": "Anzahl Betankungen",
        "about": "Entwicklung und Animation von:",
        "close": "OK",
        "about2": "© 2017 - empa move: www.empa.ch",
        "nodata": "Leider Sind zurzeit keine Livedaten vorhanden!"
      },
      "vehicles": {
        "DEFAULT": [
          {
            "name": "Audi A3 e-tron",
            "description": "Benzin und Elektro"
          }, {
            "name": "Hyundai ix35",
            "description": "Wasserstoff"
          }, {
            "name": "VW e-Golf",
            "description": "Elektro"
          }, {
            "name": "VW e-Golf",
            "description": "Elektro"
          }, {
            "name": "VW Jetta Hybrid",
            "description": "Benzin und Elektro"
          }, {
            "name": "Audi A3 g-tron",
            "description": "Benzin und CNG"
          }
        ],
        "SPECIAL": [
          {
            "name": "hy.muve",
            "description": "Der hy.muve ist ein Brennstoffzellen-Kehrfahrzeug, welches mit Wasserstoff betrieben wird. Um den Brennstoffzellenantrieb zu optimieren, wird das Kehrfahrzeug für zwei Jahre in Dübendorf betrieben und die Leistungsfähigkeit im Alltag erprobt. Im Fokus stehen insbesondere das Alterungsverhalten von Brennstoffzelle und Batterie und das Packaging im Hinblick auf eine modulare Serienfertigung."
          }, {
            "name": "Iveco Daily",
            "description": "Der Iveco Daily ist ein Lieferwagen, der mit HCNG, einem Wasserstoff/Erdgas-Gemisch, betrieben wird. Durch die Beimischung von Wasserstoff zum Erdgas ergeben sich mehrere Vorteile bezüglich Leistung und Schadstoffausstoss."
          }
        ]
      },
      "Video": {
        "title": "",
        "description": "",
        "buttons": {
          "top": {
            "right": [{
							"icon": "Schliessen",
							"label": "Schliessen",
							"type": "Video",
							"target": "Cancel"
						}],
            "left": []
          },
          "bottom": {
            "right": [],
            "left": []
          }
        }
      },
      "Transfer": {
        "title": "",
        "description": "",
        "buttons": {
          "top": {
            "right": [],
            "left": []
          },
          "bottom": {
            "right": [],
            "left": []
          }
        }
      },
      "Chart": {
        "buttons": {
          "top": {
            "right": [{
              "icon": "Schliessen",
              "label": "Schliessen",
              "type": "Chart",
              "target": "Cancel"
            }],
            "left": []
          },
          "bottom": {
            "right": [],
            "left": []
          }
        }
      },
      "Schema": {
        "buttons": {
          "top": {
            "right": [{
              "icon": "Schliessen",
              "label": "Schliessen",
              "type": "Schema",
              "target": "Cancel"
            }],
            "left": []
          },
          "bottom": {
            "right": [],
            "left": []
          }
        }
      }, "Flow": {
        "buttons": {
          "top": {
            "right": [{
              "icon": "Schliessen",
              "label": "Abbrechen",
              "type": "Unity-Event",
              "target": "Cancel"
            }],
            "left": []
          },
          "bottom": {
            "right": [],
            "left": []
          }
        }
      },
      "Home": {
        "title": "",
        "description": "",
        "buttons": {
          "top": {
            "right": [],
            "left": []
          },
          "bottom": {
            "right": [],
            "left": [{
              "icon": "Energiefluss",
              "label": "Energie-<wbr>fluss",
              "type": "Unity-Event",
              "target": "Flow"
            }, {
              "icon": "Schema",
              "label": "Anlagen-<wbr>schema",
              "type": "Schema",
              "target": "energiefluss_de.svg"
            }, {
              "icon": "Daten",
              "label": "Anlagen-<wbr>effizienz",
              "type": "Schema",
              "target": [
                {
                  "url": "efficency_move_de.svg",
                  "title": "Move Demonstrator"
                }, {
                  "url": "efficency_industrial_de.svg",
                  "title": "Industrielle Anlage"
                }
              ]
            }, {
              "icon": "Daten",
              "label": "CO<sub>2</sub>-<wbr>ersparnisse",
              "type": "Chart",
              "target": "Home"
            }]
          }
        }
      },
      "0": {
        "title": "Photovoltaik",
        "description": "Photovoltaik-Module wandeln Sonnenenergie in elektrische  Energie um. Dazu nutzen Solarzellen  den  photoelektrischen Effekt, der  mittels  Absorption von Sonnenlicht Elektronen in Bewegung setzt.  Die Kosten  für eine erneuerbare Stromproduktion durch  Photovoltaik-Module sind in den vergangenen Jahren stark gesunken und sind heute mit den Stromgestehungskosten aus  fossilen  Energieträgern  vergleichbar.  Durch die in dieser  Anlage  eingesetzten flexiblen Dünnschicht-Solarmodule können die Produktionskosten noch weiter reduziert werden.",
        "buttons": {
          "top": {
            "right": [{
              "icon": "NextEletrolyseur",
              "label": "Elektrolyseur",
              "type": "Unity-Event",
              "target": "Next"
            }],
            "left": [{
              "icon": "Move",
              "label": "Home",
              "type": "Unity-Event",
              "target": "Home"
            }]
          },
          "bottom": {
            "right": [],
            "left": [{
              "icon": "Schema",
              "label": "Technische Daten",
              "type": "Schema",
              "target": "pv_de.svg"
            }, {
              "icon": "Daten",
              "label": "Energie-<wbr>produktion",
              "type": "Chart",
              "target": "PV"
            }]
          }
        }
      },
      "1": {
        "title": "Elektrolyseur",
        "description": "Im Elektrolyseur  wird Wasser  (H<sub>2</sub>2</span>O) in seine  chemischen Bestandteile Wasserstoff (H<sub>2</sub>2</span>) und Sauerstoff (O<sub>2</sub>2</span> ) gespalten.  Dazu  benötigt  man  elektrischen  Strom,  der  aus  Gründen  der Nachhaltigkeit von erneuerbaren Energiequellen stammen sollte.  Mit Hilfe der  Elektrolyse kann  somit  elektrische  Energie in einen  chemischen Energieträger (H<sub>2</sub>2</span>) umgewandelt werden.  Die Umwandlung  bietet  den  Vorteil,  dass  sich Wasserstoff einfacher  speichern  und in der  Mobilität  nutzen lässt. Der aus der Elektrolyse gewonnene Wasserstoff wird über den Verdichter in die Speicherflaschen geführt, wo er dann bis zur Betankung gelagert wird.",
        "buttons": {
          "top": {
            "right": [{
              "icon": "NextVerdichter",
              "label": "Verdichter",
              "type": "Unity-Event",
              "target": "Next"
            }],
            "left": [{
              "icon": "Move",
              "label": "Home",
              "type": "Unity-Event",
              "target": "Home"
            }, {
              "icon": "PrevPV",
              "label": "Photovoltaik",
              "type": "Unity-Event",
              "target": "Prev"
            }]
          },
          "bottom": {
            "right": [],
            "left": [{
              "icon": "Schema",
              "label": "Technische Daten",
              "type": "Schema",
              "target": "elektrolyseur_de.svg"
            }, {
              "icon": "Daten",
              "label": "Wasserstoff-<wbr>produktion",
              "type": "Chart",
              "target": "H2"
            }]
          }
        }
      },
      "2": {
        "title": "Verdichter",
        "description": "Im Verdichter wird der Wasserstoff vom Ausgangsdruck des  Elektrolyseurs über mehrere Stufen auf den Endspeicherdruck  komprimiert. Dadurch erhöht sich der Energieinhalt pro Volumeneinheit, was die Speicherung einer grösseren Menge  Wasserstoff in Druckspeichern ermöglicht. Das hohe Druckniveau  in den Endspeichern ist die Voraussetzung für eine rasche Betankung der Fahrzeuge.",
        "buttons": {
          "top": {
            "right": [{
              "icon": "NextSpeicher",
              "label": "Speicher",
              "type": "Unity-Event",
              "target": "Next"
            }],
            "left": [{
              "icon": "Move",
              "label": "Home",
              "type": "Unity-Event",
              "target": "Home"
            }, {
              "icon": "PrevEletrolyseur",
              "label": "Elektrolyseur",
              "type": "Unity-Event",
              "target": "Prev"
            }]
          },
          "bottom": {
            "right": [],
            "left": [{
              "icon": "Schema",
              "label": "Technische Daten",
              "type": "Schema",
              "target": [
                {
                  "url": "verdichter_de.svg",
                  "title": "Verdichter 1"
                }, {
                  "url": "verdichter2_de.svg",
                  "title": "Verdichter 2"
                }
              ]
            }]
          }
        }
      },
      "3": {
        "title": "Speicher",
        "description": "Die Speicherung des Wasserstoffs erfolgt in zwei Schritten:  Die Pufferspeicher zwischen Elektrolyseur und Verdichter dienen der Nivellierung  von Produktionsschwankungen und verschaffen der Gesamtanlage eine höhere Betriebsflexibilität. Der Speicherdruck  kann dabei  zwischen  5 bar (leer) und 30 bar (voll) schwanken. Nach der Verdichtung gelangt der Wasserstoff in die Endspeicher, wo er bei einem Enddruck von 440 bar zur Betankung von Nutzfahrzeugen beziehungsweise von  900 bar zur Betankung von Personenwagen gespeichert wird.",
        "buttons": {
          "top": {
            "right": [{
              "icon": "NextTankstelle",
              "label": "Tankstelle",
              "type": "Unity-Event",
              "target": "Next"
            }],
            "left": [{
              "icon": "Move",
              "label": "Home",
              "type": "Unity-Event",
              "target": "Home"
            }, {
              "icon": "PrevVerdichter",
              "label": "Verdichter",
              "type": "Unity-Event",
              "target": "Prev"
            }]
          },
          "bottom": {
            "right": [],
            "left": [{
              "icon": "Schema",
              "label": "Technische Daten",
              "type": "Schema",
              "target": "speicher_de.svg"
            }, {
              "icon": "Daten",
              "label": "Speicherkapazität und Füllstand",
              "type": "Chart",
              "target": "Storage"
            }]
          }
        }
      },
      "4": {
        "title": "Tankstelle",
        "description": "Die Tankstelle umfasst drei Zapfsäulen, an welchen die drei gasförmigen Kraftstoffe Erdgas/Biogas (CNG), Wasserstoff (H<sub>2</sub>2</span>) und deren Gemisch (HCNG) getankt werden können. Die Betankungsdauer eines mit Erdgas/Biogas oder mit Wasserstoff betriebenen Personenwagens ist dabei vergleichbar mit der Zeit, die nötig ist, um ein konventionelles Fahrzeug zu betanken. Wie bei flüssigen Kraftstoffen gelten auch für die Abgabe von gasförmigen Kraftstoffen strenge Sicherheitsbestimmungen.",
        "buttons": {
          "top": {
            "right": [{
              "icon": "NextFahrzeuge",
              "label": "Fahrzeuge",
              "type": "Unity-Event",
              "target": "Next"
            }],
            "left": [{
              "icon": "Move",
              "label": "Home",
              "type": "Unity-Event",
              "target": "Home"
            }, {
              "icon": "PrevTankstelle",
              "label": "Tankstelle",
              "type": "Unity-Event",
              "target": "Prev"
            }]
          },
          "bottom": {
            "right": [],
            "left": [{
              "icon": "Schema",
              "label": "Technische Daten",
              "type": "Schema",
              "target": "tankstelle_de.svg"
            }, {
              "icon": "Daten",
              "label": "Anzahl Betankungen",
              "type": "Chart",
              "target": "Fuelcount"
            }]
          }
        }
      },
      "5": {
        "title": "Fahrzeuge",
        "description": "VEHICLE",
        "buttons": {
          "top": {
            "right": [],
            "left": [{
              "icon": "Move",
              "label": "Home",
              "type": "Unity-Event",
              "target": "Home"
            }, {
              "icon": "PrevTankstelle",
              "label": "Tankstelle",
              "type": "Unity-Event",
              "target": "Prev"
            }]
          },
          "bottom": {
            "right": [],
            "left": [{
              "icon": "Fahrzeuge",
              "label": "Personenwagen",
              "type": "VehicleType",
              "target": "DEFAULT"
            }, {
              "icon": "FahrzeugeSpezial",
              "label": "Spezialfahrzeug",
              "type": "VehicleType",
              "target": "SPECIAL"
            }, {
              "icon": "Tankstelle",
              "label": "Antriebssysteme",
              "type": "Schema",
              "target": [
                {
                  "url": "vehicle_electro_de.svg",
                  "title": "Elektroantrieb"
                }, {
                  "url": "vehicle_wasserstoff_de.svg",
                  "title": "Wasserstoff"
                }, {
                  "url": "vehicle_cng_de.svg",
                  "title": "CNG"
                }
              ]
            }, {
              "icon": "Schema",
              "label": "CO<sub>2</sub> Bilanz Lebenszyklus",
              "type": "Schema",
              "target": "vehicle_lifecycle_de.svg"
            }]
          }
        }
      }
    }
  };
  results: string[];
  closeResult: string;
  detailTimeout;
  detailTimeoutTime:number = 0;
  constructor(private _ngZone: NgZone, private http:HttpClient, private modalService: NgbModal) {
    this.interface = new Interface(_ngZone, this);

  }
  open(content) {
    this.modalService.open(content).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  ChangeLanguage(lang) {
    if(this.currentLocation == "Schema" || this.currentLocation == "Chart"){
      this.currentLocation = this.lastLocation;
    }
    
    this.currentLanguage =lang;
    this.showInfo = this.checkInfopanel();
    this.unity.onUnityChangeLanguage(lang);
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  ngOnInit() {
    this.http.get('assets/content.json').subscribe(data => {
      this.content = data;
      if(this.content.idle.active){
        this.pauseOverlay.WaitingForReady(this.unity);
        this.pauseOverlay.StartIdle(this.content.idle, this);
      }
    });
    this.showInfo = this.checkInfopanel();
  }
  getContent() {
    return this.content[this.currentLanguage];
  }
  
  checkInfopanel() {
    if (this.currentLocation == "Flow" || this.currentLocation == "Home" ) return false;
    if (this.content[this.currentLanguage][this.currentLocation].description == "") return false;
    else {
      let t = this.content[this.currentLanguage][this.currentLocation].description;
      if(t=="VEHICLE"){
        if(this.firstVehicle){
          this.currentVehicle = this.unity.startVehicle;
          this.firstVehicle = false;
        }
        let vehicle = this.content[this.currentLanguage].vehicles[this.vehicleType][this.currentVehicle];
        t = "<h3>"+vehicle.name+"</h3><p>"+vehicle.description+"</p>";
      }
      this.infopanel.text = t;
      this.infopanel.update();
      return true;
    }
  }
  getTitle() {
    if (this.content[this.currentLanguage][this.currentLocation].hasOwnProperty("title"))
      return this.content[this.currentLanguage][this.currentLocation].title;
    else return "";
  }
  onFlow(){
    console.log("ON FLOW");
    this.unity.onUnityEvent("Flow");
    this.currentLocation = "Flow";
  }
  onButton(button: any) {
    this.showInfo = false;
    this.detailTimeoutTime = 0;

    if (button.type == "Unity-Event") {
      if (button.target == "Cancel") {
        this.currentLocation = this.lastLocation;
      }
      else {
        if (button.target == "Next" || button.target == "Prev") {
          this.currentLocation = "Flow";
        } else {
          this.lastLocation = this.currentLocation;
          this.currentLocation = button.target;
        }
      }
      this.unity.onUnityEvent(button.target);
    }
    if (button.type == "Schema") {
      if (button.target == "Cancel") this.currentLocation = this.lastLocation;
      else {
        this.lastLocation = this.currentLocation;
        this.currentLocation = "Schema";
        this.schema.setImage(button.target);
      }
    }
    if (button.type == "Chart") {
      if (button.target == "Cancel"){
        this.chart.unsetChart();
        this.currentLocation = this.lastLocation;
      } else {
        this.lastLocation = this.currentLocation;
        this.currentLocation = "Chart";
        this.chart.setLabels(this.content[this.currentLanguage].labels);
        this.chart.setChart(button.target, this.content.url, this.content.datarefresh);
      }
    }
    if (button.type == "VehicleType") {
      this.showInfo = true;
      this.onSwitchVehicle(button.target);
    }

    if (button.type == "Video") {
      this.onVideoComplete();
    }
    if (button.target == "Cancel") {
      this.showInfo = this.checkInfopanel();
    }
  }
  onTransferStart() {
    this.lastLocation = this.currentLocation;
    this.currentLocation = "Transfer";
    this.showInfo = false;
  }
  onTransferEnd(newLocation: string) {
    this.currentLocation = newLocation;
    this.showInfo = this.checkInfopanel();
  }
  onSetLocation(newLocation: string){
    if(this.lastLocation != newLocation) this.lastLocation = this.currentLocation;
    this.currentLocation = newLocation;
    this.showInfo = this.checkInfopanel();
    this.detailTimeoutTime = 0;
    this.detailTimeout = setInterval(() => {
      this.detailTimeoutTime ++;
      if(this.detailTimeoutTime > 60*5){
        this.onDetailTimeOut();
      }
    }, 1000);
  }
  onDetailTimeOut(){
    this.detailTimeoutTime = 0;
    if (this.detailTimeout) {
      clearInterval(this.detailTimeout);
    }
    if(this.currentLocation == "Flow" || this.currentLocation == "Video") return;
    this.lastLocation = this.currentLocation;
    this.currentLocation = "Home";
    this.unity.onUnityEvent("Home");
    this.showInfo = this.checkInfopanel();
  }
  interval;
  onShowVideo(video) {
    this.detailTimeoutTime = 0;
    this.showInfo = false;
    this.video.play("assets/videos/" + video + ".mp4");
    this.currentLocation = "Video";
    this.interval = setInterval(() => {
      if (this.video.complete) {
        this.onVideoComplete();
      }
    }, 500)
  }
  onVideoComplete() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.showInfo = this.checkInfopanel();
    this.currentLocation = this.lastLocation;
    this.unity.onStopVideo();
  }
  vehicleType = "SPECIAL";
  currentVehicle = 0;
  onVehiclePrev() {
    this.currentVehicle --;

    if(this.currentVehicle < 0){
      this.currentVehicle = this.totalVehicles()-1;
    }
    this.showInfo = this.checkInfopanel();
    this.unity.onUnitySetVehicle(this.vehicleType, this.currentVehicle);
  }
  onVehicleNext() {
    this.currentVehicle ++;
    if(this.currentVehicle >= this.totalVehicles()){
      this.currentVehicle = 0;
    }
    this.showInfo = this.checkInfopanel();
    this.unity.onUnitySetVehicle(this.vehicleType, this.currentVehicle);
  }
  totalVehicles(){
    return this.content[this.currentLanguage].vehicles[this.vehicleType].length;
  }
  onSwitchVehicle(type: string) {
    if (type != this.vehicleType) {
      this.vehicleType = type;
      this.currentVehicle = -1;
      this.onVehicleNext();
    }
  }
  checkActiveVehicle(but:string){
    if(but == this.vehicleType) return true;
    else return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts